import React, { useState } from "react";
import { useForm } from 'react-hook-form';
import Swal from "sweetalert2";
import { api } from "../api";

const url_api = api + '/send-email';

export default function Contacts() {

      /*const [data, setData] = useState({
        nombre: '',
        email: '',
        asunto: '',
        mensaje: ''
    });

    const inputChange = (event) => {
        setData({
            ...data,
            [event.target.name]: event.target.value
        })

     // event.target.reset();
    }*/

    const { register, handleSubmit, reset, formState: { errors } } = useForm();

    const [isLoading, setIsLoading] = useState(false);

    const onSubmit = (data) => {
         
            setIsLoading(true);
            
            fetch(url_api, { 
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(response => {
                if (response.status === 200) {
                    setIsLoading(false);
                    Swal.fire({
                        title: 'Email enviado...',
                        text: 'Pronto le estare respondiendo',
                        confirmButtonText: 'OK'
                    });
                   reset();
                }  
            })
            .catch(error => console.log(error))

    }

    return (
        <>
            <div className="jumbotron jumbotron-fluid mb-0 contacto" >
                <div className="container mb-5" id="contact">

                    <h1 className="display-5 mb-5 text-center"> <b>Contáctame...</b></h1>

                    <div className="card offset-md-3 col-md-6 card_form" >
                        <div className="card-body">

                            <h5 className="card-title text-center mb-4 mt-2">Cómo puedo ayudarte</h5>
                            <form id="form_email" autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
                                <div className="form-group">
                                    <label htmlFor="exampleFormControlInput1">Nombre </label>
                                    <input type="text"
                                        className="form-control"
                                        id="exampleFormControlInput1"
                                        name="nombre"
                                        {...register('nombre', { required: true })} />

                                    {errors.nombre && <span style={{color:'red'}}>nombre es requerido!</span>}

                                </div>
                                
                                <div className="form-group">
                                    <label htmlFor="exampleFormControlInput1">Email </label>
                                    <input type="text"
                                        className="form-control"
                                        id="exampleFormControlInput1"
                                        name="email"
                                        {...register('email', { required: true , pattern: /^\S+@\S+$/i })}
                                    />
                                    {errors.email && errors.email.type === "required" && <span style={{color:'red'}}>email es requerido!</span>}
                                    {errors.email && errors.email.type === "pattern" && <span style={{color:'red'}}>email debe ser valido!</span> }
                                </div>

                                <div className="form-group">
                                    <label htmlFor="exampleFormControlInput1">Asunto</label>
                                    <input type="text"
                                        className="form-control"
                                        id="exampleFormControlInput1"
                                        name="asunto"
                                        {...register('asunto', { required: true })}
                                    />
                                    {errors.asunto && <span  style={{color:'red'}}>asunto es requerido!</span>}
                                </div>

                                <div className="form-group">
                                    <label htmlFor="exampleFormControlTextarea1">Mensaje</label>
                                    <textarea className="form-control"
                                        id="exampleFormControlTextarea1"
                                        rows="3"
                                        name="mensaje"
                                        {...register('mensaje', { required: true })}

                                    ></textarea>
                                    {errors.mensaje && <span  style={{color:'red'}}>mensaje es requerido!</span>}
                                </div>

                                <button type="submit" className={isLoading ? "btn btn-secondary btn-block" : "btn btn-info btn-block"} id="btn_send">
                                    {
                                        isLoading ? 'Enviando...' : 'Enviar'
                                    }
                                </button>
                            </form>
                        </div>
                    </div>

                </div>
            </div>

            <a href="#home" className="btn btn-outline-info go_top" title="Top">
                <i className="fa fa-arrow-up"></i>
            </a>
        </>
    )
}
